import axios from "axios";
import params from "../../../config/params";

require("dotenv").config();

let BASE_URL = params.PROD.MICRO_SERVICES.CAUSE.CAUSE_LIST;

if (process.env.NODE_ENV === "development") {
  BASE_URL = params.DEV.MICRO_SERVICES.CAUSE.CAUSE_LIST;
}
if (process.env.NODE_ENV === "qa") {
  BASE_URL = params.QA.MICRO_SERVICES.CAUSE.CAUSE_LIST;
}

const getCauseList = () => {
  return axios.get(
    `${BASE_URL}/cause-list`
  );
};

export default {
  getCauseList
};